module.exports = __webpack_public_path__ + "assets/61a2351b573db5ab36974d5874717539.mp3";